<template>
  <l-map :zoom="zoom" :center="center">
    <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
    <l-marker :lat-lng="markerLatLng"></l-marker>
  </l-map>
   <!-- style="height: 300px" -->
</template>

<script>
import {LMap, LTileLayer, LMarker} from 'vue2-leaflet';
import L from 'leaflet';
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: '/images/marker-icon.png',
  iconUrl: '/images/marker-icon.png',
  shadowUrl: '/images/marker-shadow.png',
});

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker
  },
  data () {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 15,
      center: [50.0773825, 14.4256044],
      markerLatLng: [50.0773825, 14.4256044]
    };
  }
}
</script>
<style scoped>
/* Default icon URLs */
.leaflet-default-icon-path {
    background-image: url(/images/marker-icon.png);
}

.leaflet-default-shadow-path {
    background-image: url(/images/marker-shadow.png);
}
</style>
